import React from "react";
import {
  SiAngular,
  SiReact,
  SiJavascript,
  SiHtml5,
  SiTypescript,
  SiCss3,
  SiBootstrap,
  SiMongodb,
  SiAndroid,
  SiMysql,
  SiGit,
} from "react-icons/si";
import { FaJava } from "react-icons/fa6";

function Skills() {
  const skills = [
    { icon: <SiAngular size={48} color="#DD0031" />, name: "Angular" },
    { icon: <SiReact size={48} color="#61DBFB" />, name: "React" },
    { icon: <SiJavascript size={48} color="#61DBFB" />, name: "JavaScript" },
    { icon: <SiTypescript size={48} color="#3178C6" />, name: "TypeScript" },
    { icon: <FaJava size={48} color="#007396" />, name: "Java" },
    { icon: <SiHtml5 size={48} color="#E34F26" />, name: "HTML" },
    { icon: <SiCss3 size={48} color="#1572B6" />, name: "CSS" },
    { icon: <SiBootstrap size={48} color="#7952B3" />, name: "Bootstrap" },
    { icon: <SiMongodb size={48} color="#4DB33D" />, name: "MongoDB" },
    { icon: <SiAndroid size={48} color="#3DDC84" />, name: "Android" },
    { icon: <SiMysql size={48} color="#4479A1" />, name: "MySQL" },
    { icon: <SiGit size={48} color="#F05032" />, name: "Git" },
  ];

  return (
    <section className="py-6 px-4 sm:px-8">
      <p className="text-center text-lg md:text-xl text-slate-300/95 mb-10 max-w-2xl mx-auto leading-relaxed">
        Here are some of the tools and technologies I’ve worked with throughout my development journey.
      </p>

      <div className="py-4 overflow-hidden">
        <div className="flex gap-10 md:gap-12 w-max animate-skill-scroll hover:[animation-play-state:paused]">
          {[...skills, ...skills].map((skill, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center"
            >
              <div className="w-24 h-24 rounded-full border border-violet-400/25 bg-gradient-to-b from-white/[0.07] to-transparent flex items-center justify-center shadow-lg shadow-indigo-950/50 hover:border-sky-400/35 hover:shadow-sky-500/15 hover:scale-110 transition-all duration-300">
                {skill.icon}
              </div>
              <span className="mt-2 text-sm text-slate-400 font-medium tracking-wide">
                {skill.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
